import { render, staticRenderFns } from "./ExportReceivedReferralsModal.vue?vue&type=template&id=1347e64a"
import script from "./ExportReceivedReferralsModal.vue?vue&type=script&lang=js"
export * from "./ExportReceivedReferralsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports